// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fhEUC","col":"styles_col__2yYkK"};